import type { TabWithTablePermissions } from '../components/TabPermissions'

export enum EOrganizationsPerm {
    ORGANIZATIONS_DELETE = 'organizations_delete',
    ORGANIZATIONS_EDIT = 'organizations_edit',
    ORGANIZATIONS_VIEW = 'organizations_view'
}
export enum EOrganizationsUsersPerm {
    ORGANIZATIONS_USERS_DELETE = 'users_delete',
    ORGANIZATIONS_USERS_EDIT = 'users_edit',
    ORGANIZATIONS_USERS_VIEW = 'users_view'
}
export const EOrganizationsUsersTabPerm: TabWithTablePermissions = {
    deletePermission: EOrganizationsUsersPerm.ORGANIZATIONS_USERS_DELETE,
    editPermission: EOrganizationsUsersPerm.ORGANIZATIONS_USERS_EDIT,
    viewPermission: EOrganizationsUsersPerm.ORGANIZATIONS_USERS_VIEW
}

export enum EOrganizationsDevicesPerm {
    ORGANIZATIONS_DEVICES_DELETE = 'devices_delete',
    ORGANIZATIONS_DEVICES_EDIT = 'devices_edit',
    ORGANIZATIONS_DEVICES_VIEW = 'devices_view'
}

export enum EOrganizationsCustomersPerm {
    ORGANIZATIONS_CUSTOMERS_DELETE = 'customers_delete',
    ORGANIZATIONS_CUSTOMERS_EDIT = 'customers_edit',
    ORGANIZATIONS_CUSTOMERS_VIEW = 'customers_view'
}
export const EOrganizationsCustomersTabPerm: TabWithTablePermissions = {
    deletePermission: EOrganizationsCustomersPerm.ORGANIZATIONS_CUSTOMERS_DELETE,
    editPermission: EOrganizationsCustomersPerm.ORGANIZATIONS_CUSTOMERS_EDIT,
    viewPermission: EOrganizationsCustomersPerm.ORGANIZATIONS_CUSTOMERS_VIEW
}

export enum EOrganizationsRolesPerm {
    ORGANIZATIONS_ROLES_DELETE = 'roles_delete',
    ORGANIZATIONS_ROLES_EDIT = 'roles_edit',
    ORGANIZATIONS_ROLES_VIEW = 'roles_view'
}
export const EOrganizationsRolesTabPerm: TabWithTablePermissions = {
    deletePermission: EOrganizationsRolesPerm.ORGANIZATIONS_ROLES_DELETE,
    editPermission: EOrganizationsRolesPerm.ORGANIZATIONS_ROLES_EDIT,
    viewPermission: EOrganizationsRolesPerm.ORGANIZATIONS_ROLES_VIEW
}

export enum EOrganizationsApisPerm {
    ORGANIZATIONS_APIS_DELETE = 'apis_delete',
    ORGANIZATIONS_APIS_EDIT = 'apis_edit',
    ORGANIZATIONS_APIS_VIEW = 'apis_view'
}
export const EOrganizationsApisTabPerm: TabWithTablePermissions = {
    deletePermission: undefined,
    editPermission: undefined,
    viewPermission: undefined
}
